export default "__VITE_ASSET__BoU7$8$G__"